import { z } from "zod";
import { MetaSchema } from "./shared";
import { UserPurchasedPackSchema } from "./shared/UserPurchasedPackSchema";

export const ActivePoolLabelSchema = z.object({
  type: z.string(),
});

export const ActivePoolTransactionSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.string().nullable(),
  useGGold: z.string().nullable(),
  useProfit: z.string().nullable(),
  hash: z.string().nullable(),
  created_at: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  status: z.string(),
  description: z.string().nullable(),
  userPurchasedPacks: z.array(UserPurchasedPackSchema),
  label: ActivePoolLabelSchema,
});

export const ActivePoolDetailsDataSchema = z.tuple([
  z.array(ActivePoolTransactionSchema),
  z.number(),
]);

const UsersInvestmentsActivePoolDetailsResponse = z.object({
  data: ActivePoolDetailsDataSchema,
  meta: MetaSchema.default,
});

export type UsersInvestmentsActivePoolDetailsResponseType = z.infer<
  typeof UsersInvestmentsActivePoolDetailsResponse
>;

export default UsersInvestmentsActivePoolDetailsResponse;
